export default angular.module("UserSettingsApp", [
    'ApiUtils.notification.userPreferences'
]);